import {
    criadorSvr
} from '../_services';

const actions = {
    
    /* funcion para recopilar los criadores del usuario */
    acListarMisCriadores() {
        return new Promise((resolve, reject) => {
            
            criadorSvr.acListarMisCriadores().then(res => {
                return resolve(res.data);
            }).catch(error => {
                return reject(error);
            })

        });

    }
}

export const criador = {
    namespaced: true,
    actions
}